class Footer {
    constructor(){
		let d_config = require('../_config/config'); // default config
		let config = require('../_config/'+serviceName+ '.config'); // service config
		let areaDataConfig = Object.assign({},d_config.configData, config.configData); // service config를 default config에 덮어쓰기

        let footerSelector = '#footer.wrap-footer';
        let markupFooter = this.getTemplate(areaDataConfig);
        
        document.querySelector(footerSelector).insertAdjacentHTML('beforeend', markupFooter);
        
        this.addEvents();
	}
	
	getTemplate(areaDataConfig){
    	let snsLists = ``;
    	let footerLinks = ``;
    	let gradeTemplate = areaDataConfig.gradeTemplate;
    	
    	for(let sns in areaDataConfig.snsList){
    		snsLists += `
			   <li class="footer-sns-items ${areaDataConfig.snsList[sns].class}"><a href="${areaDataConfig.snsList[sns].link}" target="${areaDataConfig.snsList[sns].target}">${areaDataConfig.snsList[sns].name}</a></li>
    		`
		}
    	
    	for (let menu in areaDataConfig.menu){
			footerLinks += `
				<li class="footer-links-items"><a href="${areaDataConfig.menu[menu].link}" target="${areaDataConfig.menu[menu].target}">${areaDataConfig.menu[menu].name}</a></li>
			`
		}
		let markupFooter = `
		<div class="footer footer-${areaDataConfig.serviceName}">
	   		<div class="footer-sns">
	   			${ areaDataConfig.snsList.length > 0 ?
				`<ul class="footer-sns-list footer-sns-list-kr">
				${snsLists}
				</ul>` :
				``
				}
			</div>
			<div class="footer-links">
				<ul class="footer-links-list footer-links-list-kr">
				${footerLinks + gradeTemplate}
				</ul>
			</div>
			<div class="footer-copyright">
				<div class="footer-info footer-info-ko">
				<div class="footer-info-address">${areaDataConfig.infoAddress} ${areaDataConfig.companyInfo}</div>
				<div class="footer-info-cs">${areaDataConfig.infoCS} ${areaDataConfig.companyEmail}</div>
			</div>
			<div class="copyright-studio">${areaDataConfig.copyrightStudio}</div>
			<div class="copyright-company">${areaDataConfig.copyrightCompany}</div>
			<div class="footer-logo-wrap">
				<a class="footer-logo ncsoft" href="http://kr.ncsoft.com/korean/" target="_blank">NCSOFT</a>
				<a class="footer-logo ncdinos" href="https://www.ncdinos.com/" target="_blank">NC DINOS</a>
			</div>
		</div>
		`;
		return markupFooter;
	}
	
	addEvents(){
    	let gradeElement = document.querySelector('.footer-links-list .footer-links-items.item-grade .grade-link');
    	let gradeLayer = document.querySelector('.footer-links-list .footer-links-items.item-grade .grade-link .grade-layer');
		
		document.querySelector('body').addEventListener('click', function(event) {
			if((gradeElement && gradeLayer) !== null){
				if(event.target === gradeElement){
					gradeLayer.style.display = 'block';
					
				}
				else{
					gradeLayer.style.display = 'none';
				}
			}
		});
	}

} // end of class
export default Footer;
